import { isValidElement, type ReactNode } from "react";

// Flattens a React node to its plain text content. Inlined port of
// `react-to-text` (v2.0.1): its react ^18 peer-pin, with no newer release,
// blocks React 19. The package's unused custom-resolver arg is omitted.
export const reactToText = (node: ReactNode): string => {
  if (
    typeof node === "string" ||
    typeof node === "number" ||
    typeof node === "boolean"
  ) {
    return node.toString();
  }

  if (!node) {
    return "";
  }

  if (Array.isArray(node)) {
    return node.map((child) => reactToText(child)).join("");
  }

  if (isValidElement(node)) {
    const { children } = node.props as { children?: ReactNode };
    return reactToText(children);
  }

  return "";
};
